import React, { useEffect, useState } from "react";

// The API now serves evidence files behind authenticateToken (see
// meesok-api-v2/src/modules/member_topup/routes/fileEvidence.route.ts), so
// a plain <img src="..."> can no longer load them — the browser sends no
// Authorization header for image requests. This fetches the file with the
// token and hands the browser a local blob: URL instead.
function AuthenticatedImage({ src, alt, className, onClick }) {
  const [blobUrl, setBlobUrl] = useState(null);

  useEffect(() => {
    if (!src) {
      setBlobUrl(null);
      return;
    }

    let objectUrl;
    let cancelled = false;
    const token = localStorage.getItem("token");

    fetch(src, {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    })
      .then((res) => (res.ok ? res.blob() : Promise.reject(res)))
      .then((blob) => {
        if (cancelled) return;
        objectUrl = URL.createObjectURL(blob);
        setBlobUrl(objectUrl);
      })
      .catch(() => {
        if (!cancelled) setBlobUrl(null);
      });

    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [src]);

  if (!blobUrl) return null;

  return (
    <img src={blobUrl} alt={alt} className={className} onClick={onClick} />
  );
}

export default AuthenticatedImage;
